import { render, staticRenderFns } from "./BrokerName.vue?vue&type=template&id=11719255&"
import script from "./BrokerName.vue?vue&type=script&lang=js&"
export * from "./BrokerName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports